import {
  Grid,
  TextField,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { getIn, useFormikContext } from 'formik';
import { NewCentralFormType, SpecificFilterOption } from 'modules/search/types';
import React, { useContext } from 'react';

import { Autocomplete } from '@material-ui/lab';
import FormCustomDateField from 'components/custom-date-field/form-custom-date-field';
import { AutocompleteOption, Filter, Originator, Result } from 'types';
import fetch from 'utils/fetch';
import { relationOptionsOptions } from './relation-options';
import { entityRelationOptions } from './filter-entity-relation-options';

import {
  registerClassesOptions,
  registerSubClassesOptions,
} from './filter-register-classes-options';
import RemoteAutocomplete from 'components/remote-autocomplete/remote-autocomplete';
import {
  DictionaryOption,
  SearchDictionaryContext,
} from 'modules/search/context/dictionary-context';
import SelectTextOperation from 'modules/search/form-components/search-select-text-operation';
import _, { get } from 'lodash';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRoot: {
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '8px 0',
    },
    inputField: {
      marginRight: 16,
    },
  })
);

/**
 * Fulltext body
 */
export function FulltextRowBody(rowIndex: number, disabled?: boolean) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values } = formikCtx;
  const classes = useStyles();
  const filterPath = `specificFilterRows[${rowIndex}].ftxFilterValue`;
  return (
    <>
      <Grid item xs={12} md={8} className={classes.inputField}>
        <TextField
          disabled={disabled}
          style={{ width: '100%' }}
          label="Hledaný termín"
          value={values.specificFilterRows[rowIndex].ftxFilterValue?.value}
          onChange={(e) => setFieldValue(`${filterPath}.value`, e.target.value)}

          //TODO:
          //error={getIn(errors, `${filterId}.value`)}
          //helperText={getIn(errors, `${filterId}.value`)}
        />
      </Grid>
      <Grid item xs={12} md={2} className={classes.inputField}>
        <SelectTextOperation
          name={`${filterPath}.ftxType`}
          options={[
            { label: 'Přibližná shoda', id: 'FTX' },
            { label: 'Přesná shoda', id: 'PFTX' },
          ]}
        />
      </Grid>
    </>
  );
}
/**
 * Text row body
 */
export function TextRowBody(rowIndex: number, disabled?: boolean) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values, errors } = formikCtx;
  const filterPath = `specificFilterRows[${rowIndex}]`;
  const classes = useStyles();
  const sourceKey = values.specificFilterRows[rowIndex].filterOption.sourceKey;
  const remoteSource =
    values.specificFilterRows[rowIndex].filterOption.remoteSource;
  const defaultTextOperation =
    values.specificFilterRows[rowIndex].filterOption.defaultTextOperation;
  ////////////////////////////////////

  const filterValuePath = `${filterPath}.textFilterValue.value`;

  const ctx = useContext(SearchDictionaryContext);

  const formatValue = (value: string) => {
    return { id: value, label: value };
  };

  return (
    <>
      <Grid item xs={12} md={5} className={classes.inputField}>
        {remoteSource ? (
          <RemoteAutocomplete<string>
            id={`${filterPath}-${values.specificFilterRows[rowIndex].filterOption.id}`}
            hint="Začněte psát a systém vám našeptá možné heslá"
            value={getIn(values, filterValuePath)}
            freeSolo
            onBlur={(val) => {
              setFieldValue(filterValuePath, val);
            }}
            onSelect={(_, item) => {
              if (item) {
                setFieldValue(filterValuePath, item);
                setFieldValue(
                  `${filterPath}.textFilterValue.textOperation`,
                  'MATCH_PHRASE'
                );
              }
            }}
            disabled={/* locked || */ disabled}
            mapOption={(item) => item}
            getOptionIsSelected={(option, value) => option === value}
            getOptionLabel={(option) => option as string}
            label={'Hledaný termín'}
            error={getIn(errors, filterValuePath)}
            onChangeApiCall={remoteSource.onChangeApiCall}
          />
        ) : (
          <>
            {sourceKey ? (
              <Autocomplete
                disabled={disabled || ctx.loading}
                autoComplete
                freeSolo
                filterOptions={(opts) => {
                  const crnt = getIn(values, filterValuePath);
                  return opts.filter((o) => o.label.startsWith(crnt));
                }}
                options={ctx.sources[sourceKey!]?.data ?? []}
                getOptionLabel={(option) => option.label}
                value={formatValue(
                  values.specificFilterRows[rowIndex].textFilterValue?.value ??
                    ''
                )}
                getOptionSelected={(option, value) => {
                  return (
                    option.label === value.label ||
                    option.label === ((value as unknown) as string)
                  );
                }}
                disableClearable
                onChange={(_, item) => {
                  if (item) {
                    setFieldValue(
                      filterValuePath,
                      (item as { label: string })?.label ?? item
                    );
                    setFieldValue(
                      `${filterPath}.textFilterValue.textOperation`,
                      'MATCH_PHRASE'
                    );
                  }
                }}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      label={
                        ctx.loading ? 'Načítání slovníku...' : 'Hledaný termín'
                      }
                      onChange={(e) => {
                        setFieldValue(filterValuePath, e.currentTarget.value);
                      }}
                      variant="outlined"
                      error={getIn(errors, filterValuePath)}
                      helperText={getIn(errors, filterValuePath)}
                    />
                  );
                }}
              />
            ) : (
              <TextField
                disabled={disabled}
                style={{ width: '100%' }}
                label="Hledaný termín"
                value={
                  values.specificFilterRows[rowIndex].textFilterValue?.value
                }
                onChange={(e) => setFieldValue(filterValuePath, e.target.value)}
                //TODO:
                //error={getIn(errors, `${filterId}.value`)}
                //helperText={getIn(errors, `${filterId}.value`)}
              />
            )}
          </>
        )}
      </Grid>
      <Grid item xs={12} md={2} className={classes.inputField}>
        <SelectTextOperation
          disabled={disabled}
          name={`${filterPath}.textFilterValue.textOperation`}
          defaultOption={defaultTextOperation}
        />
      </Grid>
    </>
  );
}

/**
 * Text row body
 */
export function ComplexTextRowBody(rowIndex: number, disabled?: boolean) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values, errors } = formikCtx;
  const filterPath = `specificFilterRows[${rowIndex}]`;
  const sourceKey = values.specificFilterRows[rowIndex].filterOption.sourceKey;
  const dictCtx = useContext(SearchDictionaryContext);

  const filterValuePath = `${filterPath}.complexTextFilterValue.value`;
  const filterTextOperationPath = `${filterPath}.complexTextFilterValue.textOperation`;

  //TODO: pridat podporu sourceKey
  // TODO: ten autocomplete by chcelo zjednotit s autocompletom akoje v text row body, pripadne este inde ked sa pouziva takto rovnako / az identicky

  // locked = filter was added from search result, therefore register label is not editable
  const locked = values.specificFilterRows[rowIndex].locked;
  const classes = useStyles();

  const formatValue = (value: string) => {
    return { id: value, label: value };
  };
  return (
    <>
      <Grid item xs={12} md={5} className={classes.inputField}>
        {sourceKey ? (
          <Autocomplete
            disabled={disabled || dictCtx.loading}
            autoComplete
            freeSolo
            options={dictCtx.sources[sourceKey!]?.data ?? []}
            filterOptions={(opts) => {
              const crnt = getIn(values, filterValuePath);
              return opts.filter((o) => o.label.startsWith(crnt));
            }}
            getOptionLabel={(option) => option.label}
            value={formatValue(_.get(values, filterValuePath) ?? '')}
            getOptionSelected={(option, value) => {
              return (
                option.label === value.label ||
                option.label === ((value as unknown) as string)
              );
            }}
            disableClearable
            onChange={(_, item) => {
              if (item) {
                setFieldValue(
                  filterValuePath,
                  (item as { label: string })?.label ?? item
                );
                setFieldValue(filterTextOperationPath, 'MATCH_PHRASE');
              }
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label={
                    dictCtx.loading ? 'Načítání slovníku...' : 'Hledaný termín'
                  }
                  onChange={(e) => {
                    setFieldValue(filterValuePath, e.currentTarget.value);
                  }}
                  variant="outlined"
                  error={getIn(errors, filterValuePath)}
                  helperText={getIn(errors, filterValuePath)}
                />
              );
            }}
          />
        ) : (
          <TextField
            disabled={disabled || locked}
            style={{ width: '100%' }}
            label={`Hledaný termín ${
              locked ? '(přidáno z výsledku vyhledávaní)' : ''
            }`}
            value={
              values.specificFilterRows[rowIndex].complexTextFilterValue?.value
            }
            onChange={(e) =>
              setFieldValue(
                `${filterPath}.complexTextFilterValue.value`,
                e.target.value
              )
            }
            //TODO:
            //error={getIn(errors, `${filterId}.value`)}
            //helperText={getIn(errors, `${filterId}.value`)}
          />
        )}
      </Grid>
      <Grid item xs={12} md={2} className={classes.inputField}>
        <SelectTextOperation
          disabled={disabled}
          name={`${filterPath}.complexTextFilterValue.textOperation`}
        />
      </Grid>
    </>
  );
}

/**
 * TimeRange body
 */
export function TimeRangeRowBody(rowIndex: number, disabled?: boolean) {
  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} md={3} className={classes.inputField}>
        <FormCustomDateField
          id={`specificFilterRows[${rowIndex}].timeRangeFilterValue.from`}
          label="Od"
          yearRound="floor"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3} className={classes.inputField}>
        <FormCustomDateField
          id={`specificFilterRows[${rowIndex}].timeRangeFilterValue.to`}
          label="Do"
          yearRound="ceil"
          disabled={disabled}
        />
      </Grid>
    </>
  );
}

/**
 * TimeRange body
 */
export function ComplexTimeRangeRowBody(rowIndex: number, disabled?: boolean) {
  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} md={3} className={classes.inputField}>
        <FormCustomDateField
          id={`specificFilterRows[${rowIndex}].complexDateFilterValue.from`}
          label="Od"
          yearRound="floor"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3} className={classes.inputField}>
        <FormCustomDateField
          id={`specificFilterRows[${rowIndex}].complexDateFilterValue.to`}
          label="Do"
          yearRound="ceil"
          disabled={disabled}
        />
      </Grid>
    </>
  );
}

/**
 * Relation body TODO:FIXME: wont be used anymore, CLEAN UP
 */
export function RelationRowBody(rowIndex: number, disabled?: boolean) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values, errors } = formikCtx;
  const filterPath = `specificFilterRows[${rowIndex}]`;
  // locked = filter was added from search result, therefore register label is not editable
  const locked = values.specificFilterRows[rowIndex].locked;
  const label = locked
    ? 'Název hesla (přidáno z výsledku vyhledávaní)'
    : 'Název hesla';
  const classes = useStyles();

  const onChangeApiCall = async (query: string) => {
    if (!query) {
      return [];
    }
    const filter = {
      field: 'fulltextLabel',
      value: query,
      operation: 'CONTAINS',
    };

    const body = JSON.stringify({
      filters: [filter],
      sort: [{ field: 'fulltextLabel', order: 'ASC' }],
      size: 50,
    });
    const response = await fetch('/api/originator/list', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body,
    });
    const json = (await response.json()) as Result<Originator>;
    return (json?.items ?? []).map((o) => o.label ?? '');
  };

  const valuePath = `${filterPath}.relationFilterValue.originator.label`;

  return (
    <>
      <Grid item xs={12} md={4} className={classes.inputField}>
        <RemoteAutocomplete<string>
          id={`${filterPath}-${values.specificFilterRows[rowIndex].filterOption.id}`}
          hint="Začněte psát a systém vám našeptá možné heslá"
          value={getIn(values, valuePath)}
          freeSolo
          onBlur={(val) => {
            setFieldValue(valuePath, val);
          }}
          onSelect={(_, item) => {
            if (item) {
              setFieldValue(valuePath, item);
            }
          }}
          disabled={locked || disabled}
          mapOption={(item) => item}
          getOptionIsSelected={(option, value) => option === value}
          getOptionLabel={(option) => option as string}
          label={label}
          error={getIn(errors, `${filterPath}.relationFilter.originatorId`)}
          onChangeApiCall={onChangeApiCall}
        />
      </Grid>

      <Grid item xs={12} md={3} className={classes.inputField}>
        <Autocomplete
          disabled={disabled}
          autoComplete
          options={relationOptionsOptions}
          getOptionLabel={(option) => option.label}
          value={
            values.specificFilterRows[rowIndex].relationFilterValue
              ?.relationRole
          }
          getOptionSelected={(option, value) => {
            return option?.id === value?.id;
          }}
          disableClearable
          onChange={(e, item) => {
            if (item) {
              setFieldValue(
                `${filterPath}.relationFilterValue.relationRole`,
                item
              );
            }
          }}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                label="Název role"
                variant="outlined"
                error={getIn(
                  errors,
                  `${filterPath}.relationFilterValue.relationRole`
                )}
                helperText={getIn(
                  errors,
                  `${filterPath}.relationFilter.relationLabel`
                )}
              />
            );
          }}
        />
      </Grid>
    </>
  );
}

/**
 * Relation body
 */
export function RelationV2RowBody(rowIndex: number, disabled?: boolean) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values, errors } = formikCtx;
  const filterPath = `specificFilterRows[${rowIndex}]`;
  const classes = useStyles();

  const onChangeApiCall = async (query: string) => {
    if (!query) {
      return [];
    }
    const filter = {
      field: 'fulltextLabel',
      value: query,
      operation: 'CONTAINS',
    };

    const body = JSON.stringify({
      filters: [filter],
      sort: [{ field: 'fulltextLabel', order: 'ASC' }],
      size: 50,
    });
    const response = await fetch('/api/originator/list', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body,
    });
    const json = (await response.json()) as Result<Originator>;
    return (json?.items ?? []).map((o) => o.label ?? '');
  };

  const valuePath = `${filterPath}.relationFilterValue.originator.label`;
  return (
    <>
      <Grid item xs={12} md={4} className={classes.inputField}>
        <RemoteAutocomplete<string>
          id={`${filterPath}-${values.specificFilterRows[rowIndex].filterOption.id}`}
          hint="Začněte psát a systém vám našeptá možné heslá"
          value={getIn(values, valuePath)}
          freeSolo
          onBlur={(val) => {
            setFieldValue(valuePath, val);
          }}
          onSelect={(_, item) => {
            if (item) {
              setFieldValue(valuePath, item);
            }
          }}
          disabled={disabled}
          mapOption={(item) => item}
          getOptionIsSelected={(option, value) => option === value}
          getOptionLabel={(option) => option as string}
          label={'Název hesla'}
          error={getIn(errors, `${filterPath}.relationFilter.originatorId`)}
          onChangeApiCall={onChangeApiCall}
        />
      </Grid>
      <Grid item xs={12} md={3} className={classes.inputField}>
        <Autocomplete
          autoComplete
          options={entityRelationOptions}
          getOptionLabel={(option) => option.label}
          value={
            values.specificFilterRows[rowIndex].relationFilterValue
              ?.relationRole
          }
          getOptionSelected={(option, value) => {
            return option?.id === value?.id;
          }}
          disableClearable
          onChange={(_, item) => {
            if (item) {
              setFieldValue(
                `${filterPath}.relationFilterValue.relationRole`,
                item
              );
            }
          }}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                label="Jméno vztahu"
                variant="outlined"
                error={getIn(
                  errors,
                  `${filterPath}.relationFilterValue.relationRole`
                )}
                helperText={getIn(
                  errors,
                  `${filterPath}.relationFilter.relationLabel`
                )}
              />
            );
          }}
        />
      </Grid>
    </>
  );
}

/**
 * Relation body
 */
export function RegisterNameRowBody(rowIndex: number, disabled?: boolean) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values, errors } = formikCtx;
  const filterPath = `specificFilterRows[${rowIndex}]`;
  const label = 'Název hesla';
  const classes = useStyles();

  const onChangeApiCall = async (query: string) => {
    if (!query) {
      return [];
    }
    const filter = {
      field: 'fulltextLabel',
      value: query,
      operation: 'CONTAINS',
    };

    const body = JSON.stringify({
      filters: [filter],
      sort: [{ field: 'fulltextLabel', order: 'ASC' }],
      size: 50,
    });
    const response = await fetch('/api/originator/list', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body,
    });
    const json = (await response.json()) as Result<Originator>;
    return (json?.items ?? []).map((o) => o.label ?? '');
  };

  const filterValuePath = `${filterPath}.textFilterValue.value`;

  return (
    <>
      <Grid item xs={12} md={4} className={classes.inputField}>
        <RemoteAutocomplete<string>
          id={`${filterPath}-${values.specificFilterRows[rowIndex].filterOption.id}`}
          hint="Začněte psát a systém vám našeptá možné heslá"
          value={getIn(values, filterValuePath)}
          freeSolo
          onBlur={(val) => {
            setFieldValue(filterValuePath, val);
          }}
          onSelect={(_, item) => {
            if (item) {
              setFieldValue(filterValuePath, item);
              setFieldValue(
                `${filterPath}.textFilterValue.textOperation`,
                'MATCH_PHRASE'
              );
            }
          }}
          disabled={disabled}
          mapOption={(item) => item}
          getOptionIsSelected={(option, value) => option === value}
          getOptionLabel={(option) => option as string}
          label={label}
          error={getIn(errors, filterValuePath)}
          onChangeApiCall={onChangeApiCall}
        />
      </Grid>

      <Grid item xs={12} md={2} className={classes.inputField}>
        <SelectTextOperation
          disabled={disabled}
          name={`${filterPath}.textFilterValue.textOperation`}
        />
      </Grid>
    </>
  );
}

export function ReferenceLabelsFilterBody(
  rowIndex: number,
  disabled?: boolean
) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values } = formikCtx;
  const filterPath = `specificFilterRows[${rowIndex}]`;
  const identifierTypePath = `customFilterValues[0].value`;
  const identifierValuePath = `customFilterValues[1].value`;
  const fullPath1 = `${filterPath}.${identifierTypePath}`;
  const fullPath2 = `${filterPath}.${identifierValuePath}`;
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12} md={4} className={classes.inputField}>
        <TextField
          name={fullPath1}
          disabled={disabled}
          style={{ width: '100%' }}
          label="Typ identifikátoru"
          value={getIn(values, `${filterPath}.${identifierTypePath}`)}
          onChange={(e) =>
            setFieldValue(`${filterPath}.${identifierTypePath}`, e.target.value)
          }
        />
      </Grid>
      <Grid item xs={12} md={4} className={classes.inputField}>
        <TextField
          name={fullPath2}
          disabled={disabled}
          style={{ width: '100%' }}
          label="Hodnota"
          value={getIn(values, `${filterPath}.${identifierValuePath}`)}
          onChange={(e) =>
            setFieldValue(
              `${filterPath}.${identifierValuePath}`,
              e.target.value
            )
          }
        />
      </Grid>
    </>
  );
}

export function ReferenceLabelsFilterBodyWithDictionary(
  rowIndex: number,
  disabled?: boolean
) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values } = formikCtx;
  const filterPath = `specificFilterRows[${rowIndex}]`;
  const identifierTypePath = `customFilterValues[0]`;
  const identifierValuePath = `customFilterValues[1].value`;
  const fullPath1 = `${filterPath}.${identifierTypePath}`;
  const fullPath2 = `${filterPath}.${identifierValuePath}`;
  const sourceKey = values.specificFilterRows[rowIndex].filterOption.sourceKey;
  const classes = useStyles();
  const dictCtx = useContext(SearchDictionaryContext);

  return (
    <>
      <Grid item xs={12} md={4} className={classes.inputField}>
        {sourceKey ? (
          <Autocomplete
            disabled={disabled || dictCtx.loading}
            autoComplete
            freeSolo
            options={dictCtx.sources[sourceKey!]?.data ?? []}
            filterOptions={(opts) => {
              const crnt = getIn(values, `${fullPath1}.label`);
              if (!crnt) {
                return opts;
              }
              return opts.filter((o) => o?.label?.startsWith?.(crnt));
            }}
            getOptionLabel={(option) => option?.label}
            value={
              (values.specificFilterRows[rowIndex]
                ?.customFilterValues?.[0] as unknown) as DictionaryOption
            }
            getOptionSelected={(option, value) => {
              return option?.id === value.id;
            }}
            disableClearable
            onChange={(_, item) => {
              if (item) {
                setFieldValue(fullPath1, item);
              }
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label={
                    dictCtx.loading
                      ? 'Načítání slovníku...'
                      : 'Typ identifikátoru (nepovinné)'
                  }
                  onChange={(e) => {
                    setFieldValue(`${fullPath1}.label`, e.currentTarget.value);
                    setFieldValue(`${fullPath1}.id`, e.currentTarget.value);
                  }}
                  variant="outlined"
                />
              );
            }}
          />
        ) : (
          <TextField
            name={fullPath1}
            disabled={disabled}
            style={{ width: '100%' }}
            label="Typ identifikátoru"
            value={getIn(values, `${filterPath}.${identifierTypePath}`)}
            onChange={(e) =>
              setFieldValue(
                `${filterPath}.${identifierTypePath}`,
                e.target.value
              )
            }
          />
        )}
      </Grid>
      <Grid item xs={12} md={4} className={classes.inputField}>
        <TextField
          name={fullPath2}
          disabled={disabled}
          style={{ width: '100%' }}
          label="Hodnota"
          value={getIn(values, `${filterPath}.${identifierValuePath}`)}
          onChange={(e) =>
            setFieldValue(
              `${filterPath}.${identifierValuePath}`,
              e.target.value
            )
          }
        />
      </Grid>
    </>
  );
}

export function RegisterClassesAndSubclassesFilterBody(
  rowIndex: number,
  disabled?: boolean
) {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values, errors } = formikCtx;
  const filterPath = `specificFilterRows[${rowIndex}]`;
  const classes = useStyles();
  const selectedClassId =
    values.specificFilterRows[rowIndex].registerClassesFilterValue?.class.id;
  const subClassesOptions = selectedClassId
    ? registerSubClassesOptions[selectedClassId]
    : [];

  return (
    <>
      <Grid item xs={12} md={4} className={classes.inputField}>
        <Autocomplete
          autoComplete
          disabled={disabled}
          options={registerClassesOptions}
          getOptionLabel={(option) => option.label}
          value={
            values.specificFilterRows[rowIndex].registerClassesFilterValue
              ?.class
          }
          getOptionSelected={(option, value) => {
            return option?.id === value?.id;
          }}
          disableClearable
          onChange={(e, item) => {
            if (item) {
              setFieldValue(
                `${filterPath}.registerClassesFilterValue.subClass`,
                undefined
              );
              setFieldValue(
                `${filterPath}.registerClassesFilterValue.class`,
                item
              );
            }
          }}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                label="Třída"
                variant="outlined"
                error={getIn(
                  errors,
                  `${filterPath}.registerClassesFilterValue.class`
                )}
                helperText={getIn(
                  errors,
                  `${filterPath}.registerClassesFilterValue.class`
                )}
              />
            );
          }}
        />
      </Grid>
      <Grid item xs={12} md={3} className={classes.inputField}>
        <Autocomplete
          key={selectedClassId}
          autoComplete
          disabled={disabled}
          options={subClassesOptions}
          getOptionLabel={(option) => option?.label}
          value={
            values?.specificFilterRows?.[rowIndex]?.registerClassesFilterValue
              ?.subClass
          }
          getOptionSelected={(option, value) => {
            return option?.id === value?.id;
          }}
          disableClearable
          onChange={(e, item) => {
            if (item) {
              setFieldValue(
                `${filterPath}.registerClassesFilterValue.subClass`,
                item
              );
            }
          }}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                label="Podtřída"
                variant="outlined"
                error={getIn(
                  errors,
                  `${filterPath}.registerClassesFilterValue.subClass`
                )}
                helperText={getIn(
                  errors,
                  `${filterPath}.registerClassesFilterValue.subClass`
                )}
              />
            );
          }}
        />
      </Grid>
    </>
  );
}

type RegisterClassesAndLabelCustomProps = {
  classesSelectOptions: typeof registerClassesOptions;
  defaultPreFilters?: Filter[];
};

export const getRegisterClassesAndLabelCustom = ({
  classesSelectOptions,
  defaultPreFilters,
}: RegisterClassesAndLabelCustomProps) =>
  function Body(rowIndex: number, disabled?: boolean) {
    const formikCtx = useFormikContext<NewCentralFormType>();
    const { setFieldValue, values, errors } = formikCtx;
    const filterPath = `specificFilterRows[${rowIndex}]`;
    const classValuePath = `${filterPath}.customFilterValues[0].value`;
    const registerItemValuePath = `${filterPath}.customFilterValues[1].value`;

    const classes = useStyles();

    const selectedClassId = _.get(values, classValuePath)?.id;

    const onChangeApiCall = async (
      query: string
    ): Promise<AutocompleteOption[]> => {
      if (!query) {
        return [];
      }

      const filters: Filter[] = [
        {
          field: 'fulltextLabel',
          value: query,
          operation: 'CONTAINS',
        },
      ];

      if (defaultPreFilters) {
        filters.push(...defaultPreFilters);
      }

      if (selectedClassId && selectedClassId !== '_ALL_CLASSES') {
        filters.push({
          field: 'originatorClass',
          value: selectedClassId,
          operation: 'EQ',
        });
      }

      const body = JSON.stringify({
        filters,
        sort: [{ field: 'fulltextLabel', order: 'ASC' }],
        size: 50,
      });
      const response = await fetch('/api/originator/list', {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body,
      });
      const json = (await response.json()) as Result<Originator>;
      return (json?.items ?? []).map((o) => ({
        id: o.label ?? '',
        label:
          selectedClassId === '_ALL_CLASSES' || !selectedClassId
            ? `${o.originatorClassLabel}: ${o.label ?? ''}`
            : `${o.label ?? ''}`,
      }));
    };

    return (
      <>
        <Grid item xs={12} md={2} className={classes.inputField}>
          <Autocomplete
            autoComplete
            disabled={disabled}
            options={classesSelectOptions}
            getOptionLabel={(option) => option.label}
            value={_.get(values, classValuePath)}
            getOptionSelected={(option, value) => {
              return option?.id === value?.id;
            }}
            disableClearable
            onChange={(e, item) => {
              if (item) {
                setFieldValue(registerItemValuePath, undefined);
                setFieldValue(classValuePath, item);
              }
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Třída"
                  variant="outlined"
                  error={getIn(errors, classValuePath)}
                  helperText={getIn(errors, classValuePath)}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={5} className={classes.inputField}>
          <RemoteAutocomplete<AutocompleteOption>
            // why selectedClassId? we need to clear fetched items because it could be irelevant for new selected class
            id={`${filterPath}-${values.specificFilterRows[rowIndex].filterOption.id}-${selectedClassId}`}
            hint="Začněte psát a systém vám našeptá možné heslá"
            value={getIn(values, registerItemValuePath)}
            //freeSolo
            onBlur={(val) => {
              setFieldValue(registerItemValuePath, val);
            }}
            onSelect={(_, item) => {
              if (item) {
                setFieldValue(registerItemValuePath, item);
              }
            }}
            disabled={disabled}
            mapOption={(item) => item}
            getOptionIsSelected={(option, value) =>
              get(option, 'id') === get(value, 'id')
            }
            getOptionLabel={(option) =>
              (option as AutocompleteOption)?.label ?? '--'
            }
            label={'Název hesla'}
            //error={getIn(errors, `${filterPath}.relationFilter.originatorId`)}
            error={getIn(errors, registerItemValuePath)}
            onChangeApiCall={onChangeApiCall}
          />
        </Grid>
      </>
    );
  };

export const getEadNodeUnitRelationFilterBody = ({
  classesSelectOptions,
  defaultPreFilters,
}: RegisterClassesAndLabelCustomProps) =>
  function Body(rowIndex: number, disabled?: boolean) {
    const formikCtx = useFormikContext<NewCentralFormType>();
    const { setFieldValue, values, errors } = formikCtx;
    const filterPath = `specificFilterRows[${rowIndex}]`;
    const classValuePath = `${filterPath}.customFilterValues[0].value`;
    const registerItemValuePath = `${filterPath}.customFilterValues[1].value`; // originator.label
    const relationTypeItemValuePath = `${filterPath}.customFilterValues[2].value`;

    const classes = useStyles();

    const selectedClassId = _.get(values, classValuePath)?.id;

    const onChangeApiCall = async (
      query: string
    ): Promise<AutocompleteOption[]> => {
      if (!query) {
        return [];
      }

      const filters: Filter[] = [
        {
          field: 'fulltextLabel',
          value: query,
          operation: 'CONTAINS',
        },
      ];

      if (defaultPreFilters) {
        filters.push(...defaultPreFilters);
      }

      if (selectedClassId && selectedClassId !== '_ALL_CLASSES') {
        filters.push({
          field: 'originatorClass',
          value: selectedClassId,
          operation: 'EQ',
        });
      }

      const body = JSON.stringify({
        filters,
        sort: [{ field: 'fulltextLabel', order: 'ASC' }],
        size: 50,
      });
      const response = await fetch('/api/originator/list', {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body,
      });
      const json = (await response.json()) as Result<Originator>;
      return (json?.items ?? []).map((o) => ({
        id: o.label ?? '',
        label:
          selectedClassId === '_ALL_CLASSES' || !selectedClassId
            ? `${o.originatorClassLabel}: ${o.label ?? ''}`
            : `${o.label ?? ''}`,
      }));
    };

    return (
      <>
        <Grid item xs={12} md={2} className={classes.inputField}>
          <Autocomplete
            autoComplete
            disabled={disabled}
            options={classesSelectOptions}
            getOptionLabel={(option) => option.label}
            value={_.get(values, classValuePath)}
            getOptionSelected={(option, value) => {
              return option?.id === value?.id;
            }}
            disableClearable
            onChange={(e, item) => {
              if (item) {
                setFieldValue(registerItemValuePath, undefined);
                setFieldValue(classValuePath, item);
              }
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Třída"
                  variant="outlined"
                  error={getIn(errors, classValuePath)}
                  helperText={getIn(errors, classValuePath)}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={5} className={classes.inputField}>
          <RemoteAutocomplete<AutocompleteOption>
            // why selectedClassId? we need to clear fetched items because it could be irelevant for new selected class
            id={`${filterPath}-${values.specificFilterRows[rowIndex].filterOption.id}-${selectedClassId}`}
            hint="Začněte psát a systém vám našeptá možné heslá"
            value={getIn(values, registerItemValuePath)}
            //freeSolo
            onBlur={(val) => {
              setFieldValue(registerItemValuePath, val);
            }}
            onSelect={(_, item) => {
              if (item) {
                setFieldValue(registerItemValuePath, item);
              }
            }}
            disabled={disabled}
            mapOption={(item) => item}
            getOptionIsSelected={(option, value) =>
              get(option, 'id') === get(value, 'id')
            }
            getOptionLabel={(option) =>
              (option as AutocompleteOption)?.label ?? '--'
            }
            label={'Název hesla'}
            //error={getIn(errors, `${filterPath}.relationFilter.originatorId`)}
            error={getIn(errors, registerItemValuePath)}
            onChangeApiCall={onChangeApiCall}
          />
        </Grid>
        <Grid item xs={12} md={3} className={classes.inputField}>
          <Autocomplete
            autoComplete
            disabled={disabled}
            options={relationOptionsOptions}
            getOptionLabel={(option) => option.label}
            value={
              getIn(values, relationTypeItemValuePath) ||
              relationOptionsOptions[0]
            }
            getOptionSelected={(option, value) => {
              return option?.id === value?.id;
            }}
            disableClearable
            onChange={(_, item) => {
              if (item) {
                setFieldValue(relationTypeItemValuePath, item);
              }
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Název role"
                  variant="outlined"
                  required
                  error={getIn(errors, relationTypeItemValuePath)}
                  helperText={getIn(errors, relationTypeItemValuePath)}
                />
              );
            }}
          />
        </Grid>
      </>
    );
  };

export const getFilterBody = (
  filterRow?: SpecificFilterOption
): ((rowIndex: number, disabled?: boolean) => JSX.Element) => {
  if (filterRow?.FilterBodyComponent) {
    return filterRow.FilterBodyComponent;
  }
  if (filterRow?.filterType === 'TEXT') {
    return TextRowBody;
  }
  if (filterRow?.filterType === 'RELATION') {
    return RelationRowBody;
  }

  if (filterRow?.filterType === 'RELATION_V2') {
    return RelationV2RowBody;
  }

  if (filterRow?.filterType === 'TIME_RANGE') {
    return TimeRangeRowBody;
  }

  if (filterRow?.filterType === 'COMPLEX_TEXT') {
    return ComplexTextRowBody;
  }

  if (filterRow?.filterType === 'COMPLEX_DATE') {
    return ComplexTimeRangeRowBody;
  }

  //default: fulltext body
  return FulltextRowBody;
};
